import PropTypes from 'prop-types'
import PublicNav from './PublicNav'
import Footer from './Footer'

const PricingPage = ({ onBack, onLogin, onShowFeatures, onShowAbout, onShowContact, onShowPrivacy, onShowTerms }) => {
  return (
    <div className="min-h-screen bg-gray-950">
      <PublicNav 
        onShowFeatures={() => {
          onShowFeatures()
          setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100)
        }}
        onShowPricing={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        onLogin={onLogin}
        onBack={onBack}
        activeProduct={false}
        activePricing={true}
      />

      <div className="relative py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="font-display text-5xl font-light tracking-tight text-white sm:text-7xl mb-6">
              Choose the{' '}
              <span className="text-sky-300">right plan</span> for you
            </h1>
            <p className="mx-auto max-w-3xl text-2xl/10 text-gray-300">We're in private beta right now, so pricing isn't quite ready yet. We'll share the details with you soon!</p>
          </div>
          <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 items-center gap-y-6 sm:mt-20 sm:gap-y-0 lg:max-w-4xl lg:grid-cols-2">
          <div className="relative rounded-3xl bg-gray-800 p-8 shadow-2xl ring-1 ring-white/10 sm:p-10 blur-sm opacity-60">
            <h3 id="tier-personal" className="text-xl font-semibold text-sky-400">Starter</h3>
            <p className="mt-4 flex items-baseline gap-x-2">
              <span className="text-5xl font-semibold tracking-tight text-white">TBC</span>
            </p>
            <p className="mt-6 text-xl text-gray-300">Perfect for individuals getting started.</p>
            <ul role="list" className="mt-8 space-y-3 text-base text-gray-300 sm:mt-10">
              <li className="flex gap-x-3">
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-6 w-5 flex-none text-sky-400">
                  <path d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" fillRule="evenodd" />
                </svg>
                Full access to AI specialists
              </li>
              <li className="flex gap-x-3">
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-6 w-5 flex-none text-sky-400">
                  <path d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" fillRule="evenodd" />
                </svg>
                Idea validation & analysis
              </li>
              <li className="flex gap-x-3">
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-6 w-5 flex-none text-sky-400">
                  <path d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" fillRule="evenodd" />
                </svg>
                Market research reports
              </li>
              <li className="flex gap-x-3">
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-6 w-5 flex-none text-sky-400">
                  <path d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" fillRule="evenodd" />
                </svg>
                Features & limits TBC
              </li>
            </ul>
            <button
              onClick={() => onLogin('register')}
              aria-describedby="tier-personal"
              className="mt-8 block w-full rounded-md bg-sky-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 sm:mt-10"
            >
              Get started today
            </button>
          </div>
          <div className="rounded-3xl bg-gray-800/50 p-8 ring-1 ring-white/10 sm:mx-8 sm:rounded-t-none sm:p-10 lg:mx-0 lg:rounded-tr-3xl lg:rounded-bl-none blur-sm opacity-60">
            <h3 id="tier-team" className="text-xl font-semibold text-sky-400">Professional</h3>
            <p className="mt-4 flex items-baseline gap-x-2">
              <span className="text-5xl font-semibold tracking-tight text-white">TBC</span>
            </p>
            <p className="mt-6 text-xl text-gray-300">For teams and growing businesses.</p>
            <ul role="list" className="mt-8 space-y-3 text-base text-gray-300 sm:mt-10">
              <li className="flex gap-x-3">
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-6 w-5 flex-none text-sky-400">
                  <path d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" fillRule="evenodd" />
                </svg>
                Everything in Starter
              </li>
              <li className="flex gap-x-3">
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-6 w-5 flex-none text-sky-400">
                  <path d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" fillRule="evenodd" />
                </svg>
                Team collaboration
              </li>
              <li className="flex gap-x-3">
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-6 w-5 flex-none text-sky-400">
                  <path d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" fillRule="evenodd" />
                </svg>
                Priority support
              </li>
              <li className="flex gap-x-3">
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-6 w-5 flex-none text-sky-400">
                  <path d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" fillRule="evenodd" />
                </svg>
                Features & limits TBC
              </li>
            </ul>
            <button
              onClick={() => onLogin('register')}
              aria-describedby="tier-team"
              className="mt-8 block w-full rounded-md px-3.5 py-2.5 text-center text-sm font-semibold text-white bg-white/10 ring-1 ring-inset ring-white/5 hover:bg-white/20 hover:ring-white/5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/75 sm:mt-10"
            >
              Get started today
            </button>
          </div>
          </div>
        </div>
      </div>

      <Footer variant="public" onShowFeatures={onShowFeatures} onShowPricing={() => window.scrollTo({ top: 0, behavior: 'smooth' })} onShowAbout={onShowAbout} onShowContact={onShowContact} onShowPrivacy={onShowPrivacy} onShowTerms={onShowTerms} />
    </div>
  )
}

PricingPage.propTypes = {
  onBack: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  onShowFeatures: PropTypes.func.isRequired,
  onShowAbout: PropTypes.func,
  onShowContact: PropTypes.func,
  onShowPrivacy: PropTypes.func,
  onShowTerms: PropTypes.func,
}

export default PricingPage
